import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { Wordmark } from "./Logo";
import { SITE, CATEGORIES, AREAS } from "@/data/site";

export const Footer = () => (
  <footer className="relative z-10 border-t border-white/10 bg-[#030712] mt-10" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-6 py-20 grid gap-12 md:grid-cols-12">
      <div className="md:col-span-4">
        <Wordmark />
        <p className="mt-6 text-sm text-[#a5b4c8] leading-relaxed max-w-xs">
          Rama Electricals is a trusted electrical shop in Goregaon East, Mumbai, supplying genuine wires, switches, fans and circuit protection to homes, electricians and businesses.
        </p>
        <p className="mt-6 font-mono text-xs text-[#a5b4c8]">GSTIN: {SITE.gstin}</p>
      </div>
      <div className="md:col-span-2">
        <p className="eyebrow mb-5">Pages</p>
        {[["/", "Home"], ["/about", "About us"], ["/contact", "Contact us"]].map(([to, l]) => (
          <Link key={to} to={to} className="block py-1.5 text-sm text-slate-300 hover:text-[#39FF14] transition-colors" data-testid={`footer-link-${l.split(" ")[0].toLowerCase()}`}>{l}</Link>
        ))}
      </div>
      <div className="md:col-span-3">
        <p className="eyebrow mb-5">We sell</p>
        {CATEGORIES.map((c) => <p key={c.id} className="py-1.5 text-sm text-slate-300">{c.title}</p>)}
      </div>
      <div className="md:col-span-3 space-y-4 text-sm text-slate-300">
        <p className="eyebrow mb-5">Visit</p>
        <a href={SITE.mapLink} target="_blank" rel="noreferrer" className="flex gap-3 hover:text-[#39FF14] transition-colors" data-testid="footer-address"><MapPin size={16} className="mt-0.5 shrink-0 text-[#39FF14]" />{SITE.addressFull}</a>
        <a href={`tel:${SITE.phoneRaw}`} className="flex gap-3 hover:text-[#39FF14] transition-colors" data-testid="footer-phone"><Phone size={16} className="text-[#39FF14]" />{SITE.phone}</a>
        <a href={`mailto:${SITE.email}`} className="flex gap-3 hover:text-[#39FF14] transition-colors break-all" data-testid="footer-email"><Mail size={16} className="text-[#39FF14] shrink-0" />{SITE.email}</a>
      </div>
    </div>
    <div className="mx-auto max-w-7xl px-6 pb-6 text-xs text-[#a5b4c8]">
      <p>Serving: {AREAS.join(" · ")}</p>
    </div>
    <div className="mx-auto max-w-7xl px-6 py-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-2 text-xs text-[#a5b4c8]">
      <p>© 2026 Rama Electricals. All rights reserved.</p>
      <p>rama-electricals.com</p>
    </div>
  </footer>
);
